import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react'
import { LogOut, Bell, Settings, Search, User, Calendar, HelpCircle, Crown } from 'lucide-react'
import React, { Fragment, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/reducers/authReducers' 
import { RouteConstant } from '../../routes/RouteConstant'
import { useNavigate } from 'react-router-dom'
import { setHeaderTextIntitial } from '../../redux/reducers/optionsReducers'
import AvatarBorder from '../../components/AvatarBorder'
import { IconApps, IconMenuDeep, IconPremiumRights } from '@tabler/icons-react'
import { motion, AnimatePresence } from 'framer-motion'
import { QRCode } from 'antd'

const Header = ({handleToggle}) => {

  const toggle = useSelector((state) => state.options.toggleBar)
  const user = useSelector((state) => state.auth.user);
  const options = useSelector((state) => state.options);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutUser = () => {
    navigate(RouteConstant.ROOT);
    dispatch(setHeaderTextIntitial());
    dispatch(logout());
  }

  const menuItems = [
    {
      label: "Explore Our Products",
      icon: <IconApps size="16" className="text-emerald-500" />,
      color: "success",
      onClick: ()=> navigate(RouteConstant.OURAPPS)
    },
    {
      label: "Logout",
      icon: <LogOut size="16" className="text-red-500" />,
      color: "danger",
      onClick: logoutUser
    }
  ]

    const getInitials = () => {
    return `${user.fname?.[0]?.toUpperCase() || ''}${user.lname?.[0]?.toUpperCase() || ''}`;
  };

  // const appStoreUrl = 'https://apps.apple.com/gb/app/inspector-sire-2-0-prep/id6748201188';
  // const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.siresolmarineinspectors'; // Replace with actual package name


  return (
    <Fragment>
      <div className="w-full h-[70px] flex bg-white border-b border-gray-100 top-0 shadow-sm max-[768px]:bg-white items-center px-6 text-[14px]">
        <div className='flex justify-between w-full items-center'>
          <div className='flex items-center gap-4'>
            <div className='max-[1024px]:hidden font-semibold text-[18px] bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent transition-all duration-300'>
                {options.headerText}
            </div>
            
            <div className={`hidden max-[1024px]:flex items-center gap-4`}>
              <div className='flex items-center justify-center h-[70px]'>
                <motion.button 
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleToggle} 
                className="h-10 w-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-all duration-200"
                >
                  <IconMenuDeep size={25} className='p-[5px] text-gray-700' />
                </motion.button>
              </div>
              <img src={require('../../assets/images/sire-logo-2.png')} className='w-[140px] h-[24px] max-[500px]:hidden' alt='logo' />
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <Dropdown placement="bottom-start">
              <DropdownTrigger>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <div className="text-sm font-semibold text-gray-900 ">{user?.fname} {user?.lname}</div>
                    <div className="text-xs text-gray-500">{user?.role?.name}</div>
                  </div>
                  <div className="relative cursor-pointer">
                    <div className="w-10 h-10 rounded-full bg-primaryGradient text-white flex items-center justify-center text-sm font-medium shadow-md">
                      {user.fname?.[0]?.toUpperCase() || ''}{user.lname?.[0]?.toUpperCase() || ''}
                    </div>
                    {
                      user?.subscription === "Premium" &&
                      <div className="absolute -top-1 -right-1 bg-gradient-to-r from-amber-400 to-yellow-500 p-1 rounded-md shadow-sm">
                        <Crown size={10} className="text-white" />  
                      </div>
                    }
                  </div>
                </div>
              </DropdownTrigger>
              <DropdownMenu  aria-label="User Actions" variant="flat">
                <DropdownItem key="profile" className="px-10 py-4 gap-2">
                  <p className="font-bold">Signed in as {user?.fname} {user?.lname}</p>
                </DropdownItem>
                {menuItems?.map((item, index)=>(
                  <DropdownItem onClick={item.onClick} key={index} startContent={item.icon} color={item.color}>
                    {item.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>

          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Header